/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementNoContentResponse,
  BboStockManagementUnauthorizedResponse,
  StockCount,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get stock count list for a branch
 * @summary Get the stock counts type list for a branch
 */
export const getCountTypes = (signal?: AbortSignal) => {
  return customInstance<StockCount | BboStockManagementNoContentResponse>({
    url: `/bm-stock-management-service/v1/count-types`,
    method: 'get',
    signal,
  });
};

export const getGetCountTypesQueryKey = () => {
  return [`/bm-stock-management-service/v1/count-types`] as const;
};

export const getGetCountTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCountTypes>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountTypes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCountTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountTypes>>> = ({ signal }) =>
    getCountTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCountTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCountTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getCountTypes>>>;
export type GetCountTypesQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary Get the stock counts type list for a branch
 */
export const useGetCountTypes = <
  TData = Awaited<ReturnType<typeof getCountTypes>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountTypes>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCountTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
